var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-inner section tab-charges",
      staticStyle: { "min-width": "1000px" }
    },
    [
      _c(
        "cargo-up-down-resize",
        {
          staticStyle: { height: "100%" },
          attrs: {
            "show-down": _vm.showDown,
            "show-up": _vm.showUp,
            "up-style": {
              display: "flex",
              flexDirection: "column",
              paddingBottom: _vm.showDown ? "5px" : ""
            },
            "down-style": {
              display: "flex",
              flexDirection: "column",
              paddingTop: _vm.showUp ? "5px" : ""
            }
          }
        },
        [
          _c(
            "template",
            { slot: "up" },
            [
              _vm.isBpm
                ? _c("div", [
                    _c("span", {}, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.receivable")))
                    ])
                  ])
                : _vm._e(),
              !_vm.isBpm
                ? _c("div", { staticClass: "operations" }, [
                    _c(
                      "div",
                      {
                        staticClass: "triggers",
                        on: {
                          dblclick: function($event) {
                            if ($event.target !== $event.currentTarget) {
                              return null
                            }
                            _vm.tabSelling.visible = !_vm.tabSelling.visible
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("span", {}, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.receivable")))
                            ]),
                            _vm.reCalc
                              ? _c("charge-currency-total-group", {
                                  ref: "arTotalGroup",
                                  attrs: {
                                    no: "arTotalGroup",
                                    "amount-to-currency": _vm.localCurrency,
                                    "data-provider":
                                      _vm.arTotalGroup.dataProvider,
                                    "data-field": _vm.config
                                      ._isCalculateExcludingAmount
                                      ? "amount"
                                      : "excludingTaxAmount",
                                    "rate-field": "exchangeRate",
                                    "is-gross-profit": true,
                                    "show-controlled-profit":
                                      _vm.privilege.showControlledProfit,
                                    "show-cost-controlled":
                                      _vm.privilege.isCostControlled,
                                    type: "ar",
                                    source: "chargeDetailAr",
                                    "auxiliary-map": _vm.apAuxiliaryDataMap
                                  }
                                })
                              : _vm._e(),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showEstimate,
                                    expression: "showEstimate"
                                  }
                                ]
                              },
                              [
                                _c("span", [_vm._v("(")]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("FinanceManage.charge_estimate")
                                    )
                                  )
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "text-decoration": "underline"
                                    },
                                    on: { click: _vm.editEstimateHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.estimateAccountsReceivable)
                                    )
                                  ]
                                ),
                                _c("span", [_vm._v(")")])
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.job.priceNo && _vm.job.priceNo.length,
                                expression: "job.priceNo&&job.priceNo.length"
                              }
                            ]
                          },
                          [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.job.priceNo && _vm.job.priceNo.length,
                                    expression:
                                      "job.priceNo&&job.priceNo.length"
                                  }
                                ]
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("FinanceManage.charge_sp1"))
                                )
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  placement: "top",
                                  content: _vm.$t("FinanceManage.charge_sp2")
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "text-decoration": "underline",
                                      cursor: "pointer"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.tabChargesHP.onPriceNoClick(
                                          _vm.job.priceNo,
                                          $event
                                        )
                                      },
                                      dblclick: function($event) {
                                        return _vm.tabChargesHP.onPriceNoDoubleClick()
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.job.priceNo) + " ")]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "cargo-button-group-slider",
                          {
                            staticStyle: { flex: "1", border: "none" },
                            attrs: { no: "top", align: "right" }
                          },
                          [
                            _c(
                              "div",
                              [
                                !_vm.isAdjust &&
                                _vm.config.isInputChargeBaseOnService
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          id: "serviceBtn",
                                          type: "primary",
                                          disabled:
                                            !_vm.editing ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.addServiceTypChargeEvent()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FinanceManage.charge_sp3")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.job &&
                                _vm.job.jobState === 0 &&
                                _vm.privilege.copyCharge
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.viewSource !== "salesDetail",
                                            expression:
                                              "viewSource!=='salesDetail'"
                                          }
                                        ],
                                        attrs: {
                                          id: "btnCpoyCharge",
                                          type: "primary",
                                          disabled:
                                            !_vm.editing ||
                                            (_vm.lockArWithProvision &&
                                              _vm.lockApWithProvision) ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.cpoyChargeHandler()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_copyCharge"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.job && _vm.config.toExoSystemYGSH
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          id: "btnSynchronizationLtsChargeAr",
                                          type: "primary",
                                          disabled:
                                            _vm.editing ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.synchronizationLtsCharge(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_SynchronousCloudPlatform"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.viewSource === "salesDetail" &&
                                _vm.job &&
                                _vm.job.jobState === 0 &&
                                _vm.privilege.copyCharge
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          id: "btnCpoyChargeSales",
                                          type: "primary",
                                          disabled:
                                            (_vm.lockArWithProvision &&
                                              _vm.lockApWithProvision) ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.cpoyChargeHandler()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_copyCharge"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.job && _vm.job.jobState === 0
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          id: "btnRefreshRate",
                                          type: "primary",
                                          disabled:
                                            _vm.editing ||
                                            _vm.lockArWithProvision ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.refreshRateHandler()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FinanceManage.charge_sp4")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.config.copySlaveCostToMasterCharge &&
                                !_vm.isAdjust &&
                                _vm.job.masterFlag &&
                                _vm.editing
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          disabled: !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.copySlaveCostHandler()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("FinanceManage.charge_sp5")
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.privilege.isInviteChargeConfirm &&
                                _vm.showInviteChargeConfirm
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          id: "btnInviteToConfirmCharge",
                                          type: "primary",
                                          disabled:
                                            !!_vm.editing ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.confirmInviteCharge()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_inviteToConfirmTheCharges"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.isAdjust &&
                                _vm.privilege.isPayAddChargeRole &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          id: "btnAdd1",
                                          type: "primary",
                                          disabled:
                                            !_vm.editing ||
                                            _vm.lockArWithProvision ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.addCostEventFlag = true
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FinanceManage.charge_add")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.isAdjust &&
                                _vm.privilege.isPayAddChargeRole &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          id: "btnCopy1",
                                          type: "primary",
                                          disabled:
                                            !_vm.editing ||
                                            _vm.lockArWithProvision ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.copyCharge(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FinanceManage.charge_copy")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.isAdjust &&
                                _vm.viewSource !== "salesDetail" &&
                                _vm.showArChargeAuditButton
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          id: "btnChangeSettlementAr",
                                          type: "primary",
                                          disabled:
                                            !_vm.editing ||
                                            _vm.lockArWithProvision ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.changeAccountHandler(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_ChangeSettlement"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                (_vm.isAllowedEdit &&
                                  !_vm.isAdjust &&
                                  _vm.privilege.addSpecialCharge &&
                                  _vm.viewSource !== "salesDetail" &&
                                  !_vm.job.fba) ||
                                (_vm.config.isSpecialExpenseEntryFunction &&
                                  _vm.privilege.addSpecialCharge)
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          id: "addCostSpecialOCButton",
                                          type: "primary",
                                          disabled:
                                            !_vm.btn.addCostSpecialOSButton
                                              .enabled ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.addCostSpecial(
                                              "add",
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_newSpecial"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                (_vm.isAllowedEdit &&
                                  !_vm.isAdjust &&
                                  _vm.privilege.editSpecialCharge &&
                                  _vm.viewSource !== "salesDetail" &&
                                  !_vm.job.fba) ||
                                (_vm.config.isSpecialExpenseEntryFunction &&
                                  _vm.privilege.editSpecialCharge)
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_editSpecial",
                                          type: "primary",
                                          disabled:
                                            !(
                                              !_vm.editing &&
                                              _vm.tabCost.grid.selectedRow &&
                                              _vm.tabCost.grid.selectedRow
                                                .special &&
                                              Number(_vm.job.jobState) === 0 &&
                                              !(
                                                _vm.tabCost.grid.selectedRow
                                                  .billingUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .invoiceUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .billingPaymentUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .confirmBillUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .verifiedAmount !== 0
                                              ) &&
                                              !_vm.tabCost.grid.selectedRow
                                                .accountingDate &&
                                              _vm.tabCost.grid.selectedRow
                                                .chargeState === 0
                                            ) ||
                                            (!_vm.settleBranchEnable &&
                                              !_vm.config
                                                .isSpecialExpenseEntryFunction)
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.editCostSpecial(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_editSpecial"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAllowedEdit &&
                                !_vm.isAdjust &&
                                _vm.privilege.addChange &&
                                _vm.config.isCommittedAllowAddCost &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_newChange",
                                          type: "primary",
                                          disabled:
                                            !(
                                              _vm.job &&
                                              _vm.job.jobState === 2 &&
                                              _vm.job.changeState === 2
                                            ) ||
                                            _vm.lockArWithProvision ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.addCostChange(
                                              "add",
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_newChange"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAllowedEdit &&
                                !_vm.isAdjust &&
                                _vm.privilege.addChange &&
                                _vm.config.isCommittedAllowAddCost &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_editChange",
                                          type: "primary",
                                          disabled:
                                            !(
                                              _vm.job.jobState === 2 &&
                                              _vm.job.changeState === 2 &&
                                              _vm.tabCost.grid.selectedRow &&
                                              _vm.tabCost.grid.selectedRow
                                                .adjustment &&
                                              !(
                                                _vm.tabCost.grid.selectedRow
                                                  .billingUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .invoiceUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .billingPaymentUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .confirmBillUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .verifiedAmount !== 0
                                              ) &&
                                              !_vm.tabCost.grid.selectedRow
                                                .accountingDate
                                            ) ||
                                            _vm.lockArWithProvision ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.addCostChange(
                                              "edit",
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_editChange"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAllowedEdit &&
                                !_vm.isAdjust &&
                                _vm.privilege.addChange &&
                                _vm.config.isCommittedAllowAddCost &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_deleteChange",
                                          type: "danger",
                                          disabled:
                                            !(
                                              _vm.job.jobState === 2 &&
                                              _vm.job.changeState === 2 &&
                                              _vm.tabCost.grid.selectedRow &&
                                              _vm.tabCost.grid.selectedRow
                                                .adjustment &&
                                              !(
                                                _vm.tabCost.grid.selectedRow
                                                  .billingUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .invoiceUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .billingPaymentUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .confirmBillUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .verifiedAmount !== 0
                                              ) &&
                                              !_vm.tabCost.grid.selectedRow
                                                .accountingDate
                                            ) ||
                                            _vm.lockArWithProvision ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.deleteAdjust(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_deleteChange"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.isAdjust &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          id: "btnDelete1",
                                          type: "danger",
                                          disabled:
                                            !(
                                              _vm.editing &&
                                              _vm.tabCost.grid.selectedRow &&
                                              _vm.tabChargesHP.isRowEdit(
                                                _vm.tabCost.grid.selectedRow
                                              ) &&
                                              _vm.tabChargesHP.checkDeletePersonalArCharge(
                                                _vm.tabCost.grid.selectedRow
                                              )
                                            ) ||
                                            _vm.lockArWithProvision ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.deleteCost()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_delete"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.isAdjust ||
                                _vm.viewSource === "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName: "v-permission",
                                            value: [
                                              "button_InternalBillInfo_accountAdd"
                                            ],
                                            expression:
                                              "['button_InternalBillInfo_accountAdd']"
                                          }
                                        ],
                                        attrs: {
                                          type: "success",
                                          disabled:
                                            _vm.lockArWithProvision ||
                                            !_vm.settleBranchEnable ||
                                            _vm.arSelectedCount === 0
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.createBillingFromCharges(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "+ " +
                                            _vm._s(
                                              _vm.$t(
                                                "FinanceManage.createReceivableBill"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.showUpdateDueDate
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "updateDueDateCost",
                                          type: "primary",
                                          disabled:
                                            !_vm.$checkPermission([
                                              "button_Charge_updateDueDateCost"
                                            ]) ||
                                            _vm.job.pigeonhole ||
                                            _vm.editing
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.updateDueDate(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.ModifyExpirationDate"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.isAdjust &&
                                _vm.viewSource !== "salesDetail" &&
                                !_vm.showMergeChargeItemSalesView
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_sp6",
                                          type: "primary",
                                          disabled:
                                            !(
                                              _vm.editing &&
                                              _vm.privilege.copyPayable
                                            ) ||
                                            _vm.lockArWithProvision ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.copySellingHandler()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FinanceManage.charge_sp6")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.isAdjust &&
                                _vm.showUp &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_sp7",
                                          type: "primary",
                                          disabled:
                                            !(
                                              _vm.editing &&
                                              _vm.privilege.chargeProject
                                            ) ||
                                            (_vm.lockArWithProvision &&
                                              _vm.lockApWithProvision) ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.chargeSchemeHandler()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FinanceManage.charge_sp7")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.privilege.salesChargePayable &&
                                _vm.viewSource === "salesDetail" &&
                                _vm.isOperating
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_sp7_2",
                                          type: "primary",
                                          disabled: !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.chargeSchemeHandler()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FinanceManage.charge_sp7")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAllowedEdit &&
                                !_vm.isAdjust &&
                                _vm.viewSource !== "salesDetail" &&
                                !_vm.job.fba &&
                                !_vm.showMergeChargeItemSalesView
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_sp8",
                                          type: "primary",
                                          disabled:
                                            !_vm.editing ||
                                            (_vm.lockArWithProvision &&
                                              _vm.lockApWithProvision) ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.onPrice()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FinanceManage.charge_sp8")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.config.isChargeSubmitDirect &&
                                !_vm.isAdjust &&
                                _vm.privilege.isSubmitChargeRole &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_sp10",
                                          type: "primary",
                                          disabled:
                                            !(!_vm.editing && _vm.btnEditing) ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.chargeSubmitEventHandler(
                                              1,
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FinanceManage.charge_sp10")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.config.isChargeSubmitDirect &&
                                !_vm.isAdjust &&
                                _vm.privilege.isCancelSubmitChargeRole &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_sp9",
                                          type: "primary",
                                          disabled:
                                            !(!_vm.editing && _vm.btnEditing) ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.chargeSubmitEventHandler(
                                              0,
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FinanceManage.charge_sp9")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.privilege.chargeAuditFlow
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          id: "btnAuditCost",
                                          type: "primary",
                                          disabled:
                                            _vm.editing ||
                                            (_vm.job &&
                                              _vm.job.jobState === 2) ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.chargeAuditHandler(
                                              true,
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_chargesAudit"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.privilege.chargeAuditFlow
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          id: "btnCancelAuditCost",
                                          type: "primary",
                                          disabled:
                                            _vm.editing ||
                                            (_vm.job &&
                                              _vm.job.jobState === 2) ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.chargeAuditHandler(
                                              true,
                                              false
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_cancelTheAudit"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.privilege.chargeAuditFlow
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          id: "btnRejectCost",
                                          type: "primary",
                                          disabled:
                                            _vm.editing ||
                                            (_vm.job &&
                                              _vm.job.jobState === 2) ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.chargeRejectHandler(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_chargesReject"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAllowedEdit &&
                                _vm.isAdjust &&
                                _vm.config.chargeModifyType !== 2 &&
                                _vm.privilege.addSpecialUpdate &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_specialUpdate",
                                          type: "primary",
                                          width: "120",
                                          disabled:
                                            !(
                                              _vm.job && _vm.job.jobState === 2
                                            ) || !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.addCostSpecial(
                                              "addSpecialUpdate",
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_specialUpdate"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.privilege.isCostControlled
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "controlledEventHandler",
                                          type: "primary",
                                          disabled:
                                            !(_vm.isAdjust
                                              ? true
                                              : _vm.editing) ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.controlledEventHandler(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              !_vm.editing && !_vm.isAdjust
                                                ? _vm.$t(
                                                    "FinanceManage.charge_controlled"
                                                  )
                                                : _vm.isAllCostControlled
                                                ? _vm.$t(
                                                    "FinanceManage.charge_cancelControlled"
                                                  )
                                                : _vm.$t(
                                                    "FinanceManage.charge_controlled"
                                                  )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAllowedEdit &&
                                _vm.job.masterFlag &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_sp11",
                                          type: "primary",
                                          disabled:
                                            !_vm.canShareCost ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.shareChargeCostHandler()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FinanceManage.charge_sp11")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                (_vm.isAllowedEdit &&
                                  _vm.isAdjust &&
                                  _vm.config.chargeModifyType > 1 &&
                                  _vm.job.salesChannel !== "eTowerOne") ||
                                (_vm.viewSource === "salesDetail" &&
                                  _vm.privilege.isSalesCostAddChargeRole &&
                                  _vm.job &&
                                  _vm.job.jobState === 0 &&
                                  _vm.job.salesChannel !== "eTowerOne")
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_add",
                                          type: "primary",
                                          disabled:
                                            !_vm.settleBranchEnable ||
                                            (_vm.viewSource === "salesDetail" &&
                                              _vm.lockArWithProvision)
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.addCostAdjust(
                                              "add",
                                              true,
                                              false
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FinanceManage.charge_add")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                (_vm.tabCost.grid.selectedRow &&
                                  _vm.isAllowedEdit &&
                                  _vm.isAdjust &&
                                  _vm.config.chargeModifyType > 1 &&
                                  _vm.viewSource !== "salesDetail") ||
                                (_vm.viewSource === "salesDetail" &&
                                  _vm.privilege.isSalesCostEditChargeRole &&
                                  _vm.job &&
                                  _vm.job.jobState === 0)
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_edit",
                                          type: "primary",
                                          disabled:
                                            !_vm.settleBranchEnable ||
                                            (_vm.viewSource === "salesDetail" &&
                                              _vm.lockArWithProvision)
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.addCostAdjust(
                                              "edit",
                                              true,
                                              false
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FinanceManage.charge_edit")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                (_vm.tabCost.grid.selectedRow &&
                                  _vm.isAllowedEdit &&
                                  _vm.isAdjust &&
                                  _vm.config.chargeModifyType > 1 &&
                                  _vm.tabChargesHP.checkRoleDelete(
                                    _vm.tabCost.grid.selectedRow
                                  )) ||
                                (_vm.viewSource === "salesDetail" &&
                                  _vm.privilege.salesDeleteArDeptCharge &&
                                  _vm.job &&
                                  _vm.job.jobState === 0)
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_delete",
                                          type: "danger",
                                          disabled:
                                            !_vm.settleBranchEnable ||
                                            (_vm.viewSource === "salesDetail" &&
                                              _vm.lockArWithProvision)
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.deleteAdjust(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_delete"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAllowedEdit &&
                                _vm.isAdjust &&
                                (_vm.privilege.isAdjustmentAddRole ||
                                  _vm.privilege
                                    .isAdjustmentAddRolePositiveNum) &&
                                _vm.config.chargeModifyType !== 2 &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_newAdjustment",
                                          type: "primary",
                                          disabled:
                                            !(
                                              _vm.job && _vm.job.jobState === 2
                                            ) ||
                                            !_vm.settleBranchEnable ||
                                            _vm.lockArWithProvision
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.addCostAdjust(
                                              "add",
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_newAdjustment"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAllowedEdit &&
                                _vm.isAdjust &&
                                _vm.privilege.isAdjustmentEditRole &&
                                _vm.config.chargeModifyType !== 2 &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_editAdjustment",
                                          type: "primary",
                                          disabled:
                                            !(
                                              Number(_vm.job.jobState) === 2 &&
                                              _vm.tabCost.grid.selectedRow &&
                                              !(
                                                _vm.tabCost.grid.selectedRow
                                                  .billingUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .invoiceUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .billingPaymentUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .confirmBillUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .verifiedAmount !== 0
                                              )
                                            ) ||
                                            !_vm.settleBranchEnable ||
                                            _vm.lockArWithProvision
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.addCostAdjust(
                                              "edit",
                                              true,
                                              true,
                                              false
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_editAdjustment"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAllowedEdit &&
                                _vm.isAdjust &&
                                _vm.privilege.isAdjustmentDeleteRole &&
                                _vm.config.chargeModifyType !== 2 &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "charge_deleteAdjustment",
                                          type: "danger",
                                          disabled:
                                            !(
                                              _vm.job.jobState === 2 &&
                                              _vm.tabCost.grid.selectedRow &&
                                              !(
                                                _vm.tabCost.grid.selectedRow
                                                  .billingUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .invoiceUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .billingPaymentUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .confirmBillUuid ||
                                                _vm.tabCost.grid.selectedRow
                                                  .verifiedAmount !== 0
                                              )
                                            ) ||
                                            !_vm.settleBranchEnable ||
                                            _vm.lockArWithProvision
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.addCostAdjust(
                                              "del",
                                              true,
                                              true,
                                              false
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_deleteAdjustment"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.privilege.reconciliationDiffAr
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "reconciliationDiffAr",
                                          type: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.reconciliationDiff(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_ReconciliationDiffConfirm"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      id: "btnVerified",
                                      type: "primary",
                                      disabled:
                                        !(
                                          _vm.tabCost.grid.selectedRow &&
                                          _vm.tabCost.grid.selectedRow
                                            .clearingDate
                                        ) || !_vm.settleBranchEnable
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.tabChargesHP.btnVerifiedCost_clickHandler()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "FinanceManage.charge_writeOffList"
                                        )
                                      ) + " "
                                    )
                                  ]
                                ),
                                _vm.arChargeSyncBtns.length <= 1
                                  ? [
                                      _vm.config.openMutualTrustConfig !== 0
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "btnAsyncCharges",
                                                type: "primary",
                                                disabled:
                                                  !_vm.arChargeSyncEnabled ||
                                                  _vm.editing ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.syncEntrustChargers()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_asyncCharges"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.job.lob === "SE" &&
                                      _vm.config.enableEntrustmentSI &&
                                      _vm.config.chargeSyncNeedConfirm
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "btnSyncArChargesSE",
                                                type: "primary",
                                                disabled:
                                                  !_vm.arChargeSyncEnabled ||
                                                  _vm.editing ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.syncChargesToImportJob(
                                                    true
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_asyncCharges"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.job.lob === "SI" &&
                                      _vm.config.enableEntrustmentSI
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "btnSyncArChargesSI",
                                                type: "primary",
                                                disabled:
                                                  !_vm.arChargeSyncEnabled ||
                                                  _vm.editing ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.syncChargesToExportJob(
                                                    true
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_asyncCharges"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.job.lob === "AE" &&
                                      _vm.config.consignationImportByAE &&
                                      _vm.config.chargeSyncNeedConfirm
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "btnSyncArChargesAE",
                                                type: "primary",
                                                disabled:
                                                  !_vm.arChargeSyncEnabled ||
                                                  _vm.editing ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.syncChargesToImportJob(
                                                    true
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_asyncCharges"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.job.lob === "AI" &&
                                      _vm.config.consignationImportByAE
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "btnSyncArChargesAI",
                                                type: "primary",
                                                disabled:
                                                  !_vm.arChargeSyncEnabled ||
                                                  _vm.editing ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.syncChargesToExportJob(
                                                    true
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_asyncCharges"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  : _vm._e(),
                                _vm.arChargeSyncBtns.length > 1
                                  ? [
                                      _c(
                                        "el-dropdown",
                                        {
                                          staticStyle: { margin: "0 5px" },
                                          attrs: {
                                            "split-button": "",
                                            type: "primary",
                                            disabled:
                                              !_vm.arChargeSyncEnabled ||
                                              _vm.editing ||
                                              !_vm.settleBranchEnable
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.tabChargesHP.arChargeSyncHandler()
                                            },
                                            command: function(p) {
                                              _vm.arChargeSyncCommand = p
                                              _vm.tabChargesHP.arChargeSyncHandler()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.arChargeSyncCommand) +
                                              " "
                                          ),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown"
                                            },
                                            _vm._l(
                                              _vm.arChargeSyncBtns,
                                              function(item, index) {
                                                return _c(
                                                  "el-dropdown-item",
                                                  {
                                                    key: index,
                                                    attrs: {
                                                      command: item.name
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(item.name))]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  : _vm._e(),
                                _vm.$checkPermission([
                                  "button_financeModule_audit"
                                ]) && _vm.config.jinRongExchangeMode
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "syncCloudStarrySkyAr",
                                          disabled:
                                            _vm.editing ||
                                            _vm.job.jobState !== 2,
                                          type: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.syncCloudStarrySky(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.SyncCloudStarrySky"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAllowedEdit &&
                                !_vm.isAdjust &&
                                !_vm.batchAmendmentFee &&
                                _vm.privilege.applyAddCharge &&
                                _vm.config.applyChangeChargeButton &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "applyAddCharge",
                                          type: "primary",
                                          disabled:
                                            !(_vm.job.jobState === 2) ||
                                            !_vm.settleBranchEnable ||
                                            (_vm.config.toExoSystemHC &&
                                              _vm.lockArWithProvision)
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.applyChangeCharge(
                                              "add",
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "ChangeCharge.applyAddCharge"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAllowedEdit &&
                                !_vm.isAdjust &&
                                _vm.privilege.applyChangeCharge &&
                                _vm.config.applyChangeChargeButton &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "applyChangeCharge",
                                          type: "primary",
                                          disabled:
                                            !(
                                              _vm.job.jobState === 2 ||
                                              (_vm.job.jobState === 1 &&
                                                _vm.batchAmendmentFee)
                                            ) ||
                                            !_vm.settleBranchEnable ||
                                            (_vm.config.toExoSystemHC &&
                                              _vm.lockArWithProvision)
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.applyChangeCharge(
                                              "edit",
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "ChangeCharge.applyChangeCharge"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAllowedEdit &&
                                !_vm.isAdjust &&
                                !_vm.batchAmendmentFee &&
                                _vm.privilege.applyDeleteCharge &&
                                _vm.config.applyChangeChargeButton &&
                                _vm.viewSource !== "salesDetail"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "applyDeleteCharge",
                                          type: "danger",
                                          disabled:
                                            !(_vm.job.jobState === 2) ||
                                            !_vm.settleBranchEnable ||
                                            (_vm.config.toExoSystemHC &&
                                              _vm.lockArWithProvision)
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.applyChangeCharge(
                                              "del",
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "ChangeCharge.applyDeleteCharge"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.privilege.applyChangeCharge &&
                                _vm.config.applyChangeChargeButton &&
                                _vm.viewSource !== "salesDetail" &&
                                !_vm.batchAmendmentFee
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "showChangingCharge",
                                          type: "primary",
                                          disabled: !(_vm.job.jobState === 2)
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.showApplyChangingCharge()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "ChangeCharge.showApplyChangingCharge"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.job.relatedJob &&
                                !_vm.editing &&
                                !_vm.isCrossTenantSeToSi &&
                                !_vm.config.chargeSyncNeedConfirm
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "asyncChargesToImportJob",
                                          type: "primary",
                                          disabled: !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.asyncChargesToImportJob(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_asyncChargesToImportJob"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAllowedEdit &&
                                _vm.privilege.generateChargeByContractNo &&
                                _vm.config.contractBinding &&
                                _vm.viewSource !== "salesDetail" &&
                                _vm.job.lob === "SE"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "generateByContract",
                                          type: "primary",
                                          disabled:
                                            !(
                                              !_vm.editing &&
                                              _vm.btnEditing &&
                                              _vm.job.jobState === 0
                                            ) || !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.generateChargeByContractNo()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "ChangeCharge.generateByContract"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.$checkPermission([
                                            "button_Charge_lockReceivable"
                                          ]) &&
                                          !_vm.lockArWithProvision &&
                                          _vm.showLockButton &&
                                          _vm.viewSource !== "salesDetail",
                                        expression:
                                          "$checkPermission(['button_Charge_lockReceivable']) && !lockArWithProvision && showLockButton && viewSource!=='salesDetail'"
                                      }
                                    ],
                                    attrs: {
                                      no: "LockAr",
                                      type: "primary",
                                      disabled:
                                        _vm.editing || !_vm.settleBranchEnable
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.tabChargesHP.modifyChargeLockStatus(
                                          true,
                                          1
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.LockAr")) + " "
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.lockArWithProvision &&
                                          _vm.showLockButton &&
                                          _vm.viewSource !== "salesDetail",
                                        expression:
                                          "lockArWithProvision && showLockButton && viewSource!=='salesDetail'"
                                      }
                                    ],
                                    attrs: {
                                      no: "UnLockAr",
                                      type: "primary",
                                      disabled:
                                        _vm.editing ||
                                        !_vm.settleBranchEnable ||
                                        !_vm.$checkPermission([
                                          "button_Charge_unLockReceivable"
                                        ])
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.tabChargesHP.modifyChargeLockStatus(
                                          true,
                                          0
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.UnLockAr")) + " "
                                    )
                                  ]
                                ),
                                _vm.isAllowedEdit &&
                                _vm.job.lob === "SI" &&
                                _vm.job.trustFromJob &&
                                _vm.isCrossTenantSeToSi
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "syncChargesConfirmStatus",
                                          type: "primary",
                                          disabled:
                                            _vm.editing ||
                                            !(
                                              _vm.job.jobState === -1 ||
                                              _vm.job.jobState === 0
                                            ) ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.updateChargeSyncConfirmStatus(
                                              1
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_syncChargesConfirmStatus"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAllowedEdit &&
                                _vm.job.lob === "SI" &&
                                _vm.job.trustFromJob &&
                                _vm.isCrossTenantSeToSi
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "cancelSyncChargesConfirmStatus",
                                          type: "primary",
                                          disabled:
                                            _vm.editing ||
                                            !(
                                              _vm.job.jobState === -1 ||
                                              _vm.job.jobState === 0
                                            ) ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.updateChargeSyncConfirmStatus(
                                              0
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_cancelSyncChargesConfirmStatus"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.job.relatedJob &&
                                !_vm.editing &&
                                _vm.isCrossTenantSeToSi
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "syncChargesToSI",
                                          type: "primary",
                                          disabled:
                                            _vm.job.jobState !== 0 ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.crossTenantSEToSICharge(
                                              1
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_syncChargesToSI"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.job.relatedJob &&
                                !_vm.editing &&
                                _vm.isCrossTenantSeToSi
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "cancelSyncChargesToSI",
                                          type: "primary",
                                          disabled:
                                            _vm.job.jobState !== 0 ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.crossTenantSEToSICharge(
                                              0
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_cancelSyncChargesToSI"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.$checkPermission([
                                            "button_Charge_easSync"
                                          ]) &&
                                          _vm.config.toExoSystemEAS &&
                                          _vm.showLockButton &&
                                          _vm.viewSource !== "salesDetail",
                                        expression:
                                          "$checkPermission(['button_Charge_easSync']) && config.toExoSystemEAS && showLockButton && viewSource!=='salesDetail'"
                                      }
                                    ],
                                    attrs: {
                                      no: "SyncChargeToEas",
                                      type: "primary",
                                      disabled:
                                        _vm.editing || !_vm.settleBranchEnable
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.tabChargesHP.syncChargeToEas(
                                          true
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.SyncChargeToEas")
                                      ) + " "
                                    )
                                  ]
                                ),
                                _vm.showChargeSyncRecord
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "btnChargeSyncRecord",
                                          type: "primary",
                                          disabled:
                                            _vm.editing ||
                                            !_vm.settleBranchEnable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.showChargeSyncRecord()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.charge_asyncChargeRecords"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isBusinessModuleList &&
                                _vm.privilege.updateRemarkCharge
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "updateRemarks",
                                          type: "primary",
                                          disabled: !_vm.isOperating
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.updateRemark(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.AdditionalCostRemarks"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isBusinessFinanceManage &&
                                _vm.privilege.updateRemarkCharge
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "updateRemarks",
                                          type: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabChargesHP.updateRemark(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FinanceManage.AdditionalCostRemarks"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "filters" })
                  ])
                : _vm._e(),
              _c("cargo-ag-grid-wrapper", {
                ref: "tabCostGrid",
                staticStyle: {
                  "flex-grow": "1",
                  "margin-top": "10px",
                  "padding-right": "10px"
                },
                attrs: {
                  no: "130111",
                  "grid-options": _vm.tabCost.grid.gridOptions,
                  "column-defs": _vm.dynamicColumnDefsForCost,
                  "sum-column-defs": _vm.arSumColumnDefs,
                  "grid-params": _vm.tabCost.grid.gridParams,
                  "config-module": "130111",
                  "row-data": _vm.tabCost.grid.overseaCostDetails,
                  "cancel-sort-auto-reduce": false,
                  "min-height": "100px",
                  "show-row-groups": _vm.dataListDragGroup,
                  "has-export-role":
                    !_vm.customerSalesDisplay ||
                    (_vm.customerSalesDisplay &&
                      !(
                        this.viewSource === "RemoteBooking" ||
                        this.viewSource === "salesDetail"
                      )),
                  "pre-column-state-callback": _vm.preColumnStateCallback
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.tabCost.grid, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.tabCost.grid, "gridParams", $event)
                  },
                  gridReady: _vm.onCostGridReady,
                  columnRowGroupChanged: function($event) {
                    _vm.tabCost.grid.groupColumns = $event
                    _vm.tabCost.grid.groupRowNode = {}
                  }
                }
              })
            ],
            1
          ),
          _c(
            "template",
            { slot: "down" },
            [
              _vm.isBpm
                ? _c("div", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("SeaExport.payable")))])
                  ])
                : _vm._e(),
              !_vm.isBpm
                ? _c(
                    "div",
                    {
                      staticClass: "operations",
                      style: { marginTop: _vm.showUp ? "10px" : "" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "triggers" },
                        [
                          _c(
                            "div",
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("SeaExport.payable")))
                              ]),
                              _vm.reCalc
                                ? _c("charge-currency-total-group", {
                                    ref: "apTotalGroup",
                                    attrs: {
                                      no: "apTotalGroup",
                                      "amount-to-currency": _vm.localCurrency,
                                      "data-provider":
                                        _vm.apTotalGroup.dataProvider,
                                      "data-field": _vm.config
                                        ._isCalculateExcludingAmount
                                        ? "amount"
                                        : "excludingTaxAmount",
                                      "rate-field": "exchangeRate",
                                      "is-gross-profit": true,
                                      "show-controlled-profit":
                                        _vm.privilege.showControlledProfit,
                                      "show-controlled":
                                        _vm.privilege.isControlled,
                                      type: "ap",
                                      source: "chargeDetailAp",
                                      "auxiliary-map": _vm.arAuxiliaryDataMap
                                    }
                                  })
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showEstimate,
                                      expression: "showEstimate"
                                    }
                                  ]
                                },
                                [
                                  _c("span", [_vm._v("(")]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("FinanceManage.charge_estimate")
                                      )
                                    )
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "text-decoration": "underline"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.estimateAccountsPayable)
                                      )
                                    ]
                                  ),
                                  _c("span", [_vm._v(")")])
                                ]
                              )
                            ],
                            1
                          ),
                          !_vm.showMergeChargeItemSalesView
                            ? _c(
                                "cargo-button-group-slider",
                                {
                                  staticStyle: { flex: "1", border: "none" },
                                  attrs: { no: "bottom", align: "right" }
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _vm.job &&
                                      _vm.job.jobState === 0 &&
                                      _vm.privilege.copyCharge &&
                                      !_vm.showUp
                                        ? _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.viewSource !==
                                                    "salesDetail",
                                                  expression:
                                                    "viewSource!=='salesDetail'"
                                                }
                                              ],
                                              attrs: {
                                                id: "btnCpoyCharge2",
                                                type: "primary",
                                                disabled:
                                                  !_vm.editing ||
                                                  (_vm.lockArWithProvision &&
                                                    _vm.lockApWithProvision) ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.cpoyChargeHandler()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_copyCharge"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.job && _vm.config.toExoSystemYGSH
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                id:
                                                  "btnSynchronizationLtsChargeAp",
                                                type: "primary",
                                                disabled:
                                                  _vm.editing ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.synchronizationLtsCharge(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_SynchronousCloudPlatform"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                !_vm.isAdjust &&
                                                _vm.privilege
                                                  .isCostAddChargeRole &&
                                                _vm.viewSource !==
                                                  "salesDetail",
                                              expression:
                                                "!isAdjust && privilege.isCostAddChargeRole && viewSource!=='salesDetail'"
                                            }
                                          ],
                                          attrs: {
                                            id: "btnAdd2",
                                            type: "primary",
                                            disabled:
                                              !_vm.editing ||
                                              _vm.lockApWithProvision ||
                                              !_vm.settleBranchEnable
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.addSellingEventFlag = true
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("FinanceManage.charge_add")
                                            ) + " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                !_vm.isAdjust &&
                                                _vm.privilege
                                                  .isCostAddChargeRole &&
                                                _vm.viewSource !==
                                                  "salesDetail",
                                              expression:
                                                "!isAdjust && privilege.isCostAddChargeRole && viewSource!=='salesDetail'"
                                            }
                                          ],
                                          attrs: {
                                            id: "btnCopy2",
                                            type: "primary",
                                            disabled:
                                              !_vm.editing ||
                                              _vm.lockApWithProvision ||
                                              !_vm.settleBranchEnable
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.tabChargesHP.copyCharge(
                                                false
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "FinanceManage.charge_copy"
                                              )
                                            ) + " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                !_vm.isAdjust &&
                                                _vm.viewSource !==
                                                  "salesDetail" &&
                                                _vm.showApChargeAuditButton,
                                              expression:
                                                "!isAdjust && viewSource!=='salesDetail' && showApChargeAuditButton"
                                            }
                                          ],
                                          attrs: {
                                            id: "btnChangeSettlementAp",
                                            type: "primary",
                                            disabled:
                                              !_vm.editing ||
                                              _vm.lockApWithProvision ||
                                              !_vm.settleBranchEnable
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.tabChargesHP.changeAccountHandler(
                                                false
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_ChangeSettlement"
                                              )
                                            ) + " "
                                          )
                                        ]
                                      ),
                                      (_vm.isAllowedEdit &&
                                        !_vm.isAdjust &&
                                        _vm.privilege.addSpecialCharge &&
                                        _vm.viewSource !== "salesDetail" &&
                                        !_vm.job.fba) ||
                                      (_vm.config
                                        .isSpecialExpenseEntryFunction &&
                                        _vm.privilege.addSpecialCharge)
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                id: "addCostSpecialOSButton",
                                                type: "primary",
                                                disabled:
                                                  !_vm.btn
                                                    .addCostSpecialOCButton
                                                    .enabled ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.addCostSpecial(
                                                    "add",
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_newSpecial"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      (_vm.isAllowedEdit &&
                                        !_vm.isAdjust &&
                                        _vm.privilege.editSpecialCharge &&
                                        _vm.viewSource !== "salesDetail" &&
                                        !_vm.job.fba) ||
                                      (_vm.config
                                        .isSpecialExpenseEntryFunction &&
                                        _vm.privilege.editSpecialCharge)
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_editSpecial",
                                                type: "primary",
                                                disabled:
                                                  !(
                                                    !_vm.editing &&
                                                    _vm.tabSelling.grid
                                                      .selectedRow &&
                                                    _vm.tabSelling.grid
                                                      .selectedRow.special &&
                                                    _vm.job.jobState === 0 &&
                                                    !(
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .billingUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .invoiceUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .billingPaymentUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .confirmBillUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .verifiedAmount !== 0
                                                    ) &&
                                                    !_vm.tabSelling.grid
                                                      .selectedRow
                                                      .accountingDate &&
                                                    _vm.tabSelling.grid
                                                      .selectedRow
                                                      .chargeState === 0
                                                  ) ||
                                                  (!_vm.settleBranchEnable &&
                                                    !_vm.config
                                                      .isSpecialExpenseEntryFunction)
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.editCostSpecial(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_editSpecial"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.config
                                        .isSpecialExpenseEntryFunction &&
                                      _vm.privilege.addBusinessSpecialCharge
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                id:
                                                  "addCostBusinessSpecialButton",
                                                type: "primary",
                                                disabled:
                                                  !_vm.btn
                                                    .addCostBusinessSpecialButton
                                                    .enabled ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.addCostBusinessSpecial(
                                                    "add"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_newBusinessSpecial"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.config
                                        .isSpecialExpenseEntryFunction &&
                                      _vm.privilege.editBusinessSpecialCharge
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no:
                                                  "charge_editBusinessSpecial",
                                                type: "primary",
                                                disabled:
                                                  !(
                                                    !_vm.editing &&
                                                    _vm.tabSelling.grid
                                                      .selectedRow &&
                                                    _vm.tabSelling.grid
                                                      .selectedRow
                                                      .businessSpecial &&
                                                    _vm.job.jobState === 0 &&
                                                    !(
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .billingUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .invoiceUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .billingPaymentUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .confirmBillUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .verifiedAmount !== 0
                                                    ) &&
                                                    !_vm.tabSelling.grid
                                                      .selectedRow
                                                      .accountingDate &&
                                                    _vm.tabSelling.grid
                                                      .selectedRow
                                                      .chargeState === 0
                                                  ) || !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.editCostBusinessSpecial()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_editBusinessSpecial"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.isAllowedEdit &&
                                      !_vm.isAdjust &&
                                      _vm.privilege.addChange &&
                                      _vm.config.isCommittedAllowAddCost &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_newChange",
                                                type: "primary",
                                                disabled:
                                                  !(
                                                    _vm.job &&
                                                    _vm.job.jobState === 2 &&
                                                    _vm.job.changeState === 2
                                                  ) ||
                                                  _vm.lockApWithProvision ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.addCostChange(
                                                    "add",
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_newChange"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.isAllowedEdit &&
                                      !_vm.isAdjust &&
                                      _vm.privilege.addChange &&
                                      _vm.config.isCommittedAllowAddCost &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_editChange",
                                                type: "primary",
                                                disabled:
                                                  !(
                                                    _vm.job.jobState === 2 &&
                                                    _vm.job.changeState === 2 &&
                                                    _vm.tabSelling.grid
                                                      .selectedRow &&
                                                    _vm.tabSelling.grid
                                                      .selectedRow.adjustment &&
                                                    !(
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .billingUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .invoiceUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .billingPaymentUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .confirmBillUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .verifiedAmount !== 0
                                                    ) &&
                                                    !_vm.tabSelling.grid
                                                      .selectedRow
                                                      .accountingDate
                                                  ) ||
                                                  _vm.lockApWithProvision ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.addCostChange(
                                                    "edit",
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_editChange"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.isAllowedEdit &&
                                      !_vm.isAdjust &&
                                      _vm.privilege.addChange &&
                                      _vm.config.isCommittedAllowAddCost &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_deleteChange",
                                                type: "danger",
                                                disabled:
                                                  !(
                                                    _vm.job.jobState === 2 &&
                                                    _vm.job.changeState === 2 &&
                                                    _vm.tabSelling.grid
                                                      .selectedRow &&
                                                    _vm.tabSelling.grid
                                                      .selectedRow.adjustment &&
                                                    !(
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .billingUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .invoiceUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .billingPaymentUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .confirmBillUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .verifiedAmount !== 0
                                                    ) &&
                                                    !_vm.tabSelling.grid
                                                      .selectedRow
                                                      .accountingDate
                                                  ) ||
                                                  _vm.lockApWithProvision ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.deleteAdjust(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_deleteChange"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      !_vm.isAdjust &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                id: "btnDelete2",
                                                type: "danger",
                                                disabled:
                                                  !(
                                                    _vm.editing &&
                                                    _vm.tabSelling.grid
                                                      .selectedRow &&
                                                    _vm.tabChargesHP.isRowEdit(
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                    ) &&
                                                    _vm.tabChargesHP.checkDeletePersonalApCharge(
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                    )
                                                  ) ||
                                                  _vm.lockApWithProvision ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.deleteSelling()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_delete"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      !_vm.isAdjust ||
                                      _vm.viewSource === "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permission",
                                                  rawName: "v-permission",
                                                  value: [
                                                    "button_InternalBillInfo_payAdd"
                                                  ],
                                                  expression:
                                                    "['button_InternalBillInfo_payAdd']"
                                                }
                                              ],
                                              attrs: {
                                                type: "success",
                                                disabled:
                                                  _vm.lockApWithProvision ||
                                                  !_vm.settleBranchEnable ||
                                                  _vm.apSelectedCount === 0
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.createBillingFromCharges(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "+ " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FinanceManage.createPayableBill"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.showUpdateDueDate
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "updateDueDateSell",
                                                type: "primary",
                                                disabled:
                                                  !_vm.$checkPermission([
                                                    "button_Charge_updateDueDateSell"
                                                  ]) ||
                                                  _vm.job.pigeonhole ||
                                                  _vm.editing
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.updateDueDate(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.ModifyExpirationDate"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      !_vm.isAdjust &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_copyCost",
                                                type: "primary",
                                                disabled:
                                                  !(
                                                    _vm.editing &&
                                                    _vm.privilege.copyReceivable
                                                  ) ||
                                                  _vm.lockApWithProvision ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.copyCostHandler()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_copyCost"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      !_vm.isAdjust &&
                                      !_vm.showUp &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_sp7",
                                                type: "primary",
                                                disabled:
                                                  !_vm.editing ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.chargeSchemeHandler()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_sp7"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.config.isChargeSubmitDirect &&
                                      !_vm.isAdjust &&
                                      _vm.privilege.isSubmitChargeRole &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_sp10",
                                                type: "primary",
                                                disabled:
                                                  !(
                                                    !_vm.editing &&
                                                    _vm.btnEditing
                                                  ) || !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.chargeSubmitEventHandler(
                                                    1
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_sp10"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.config.isChargeSubmitDirect &&
                                      !_vm.isAdjust &&
                                      _vm.privilege.isCancelSubmitChargeRole &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_sp9",
                                                type: "primary",
                                                disabled:
                                                  !(
                                                    !_vm.editing &&
                                                    _vm.btnEditing
                                                  ) || !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.chargeSubmitEventHandler(
                                                    0
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_sp9"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.privilege.chargeAuditFlow
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                id: "btnAuditSelling",
                                                type: "primary",
                                                disabled:
                                                  _vm.editing ||
                                                  (_vm.job &&
                                                    _vm.job.jobState === 2) ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.chargeAuditHandler(
                                                    false,
                                                    true
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_chargesAudit"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.privilege.chargeAuditFlow
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                id: "btnCancelAuditSelling",
                                                type: "primary",
                                                disabled:
                                                  _vm.editing ||
                                                  (_vm.job &&
                                                    _vm.job.jobState === 2) ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.chargeAuditHandler(
                                                    false,
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_cancelTheAudit"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.privilege.chargeAuditFlow
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                id: "btnRejectSelling",
                                                type: "primary",
                                                disabled:
                                                  _vm.editing ||
                                                  (_vm.job &&
                                                    _vm.job.jobState === 2) ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.chargeRejectHandler(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_chargesReject"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.isAllowedEdit &&
                                      _vm.isAdjust &&
                                      _vm.config.chargeModifyType !== 2 &&
                                      _vm.privilege.addSpecialUpdate &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_specialUpdate",
                                                type: "primary",
                                                width: "120",
                                                disabled:
                                                  !(
                                                    _vm.job &&
                                                    _vm.job.jobState === 2
                                                  ) || !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.addCostSpecial(
                                                    "addSpecialUpdate",
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_specialUpdate"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.privilege.isControlled
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "controlledEventHandler",
                                                type: "primary",
                                                disabled:
                                                  !(_vm.isAdjust
                                                    ? true
                                                    : _vm.editing) ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.controlledEventHandler(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    !_vm.editing &&
                                                      !_vm.isAdjust
                                                      ? _vm.$t(
                                                          "FinanceManage.charge_controlled"
                                                        )
                                                      : _vm.isAllSellingControlled
                                                      ? _vm.$t(
                                                          "FinanceManage.charge_cancelControlled"
                                                        )
                                                      : _vm.$t(
                                                          "FinanceManage.charge_controlled"
                                                        )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      (_vm.isAllowedEdit &&
                                        _vm.isAdjust &&
                                        _vm.config.chargeModifyType > 1 &&
                                        _vm.job.salesChannel !== "eTowerOne") ||
                                      (_vm.viewSource === "salesDetail" &&
                                        _vm.privilege.isSalesPayAddChargeRole &&
                                        _vm.job &&
                                        _vm.job.jobState === 0 &&
                                        _vm.job.salesChannel !== "eTowerOne")
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_add",
                                                type: "primary",
                                                disabled:
                                                  !_vm.settleBranchEnable ||
                                                  (_vm.viewSource ===
                                                    "salesDetail" &&
                                                    _vm.lockApWithProvision)
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.addCostAdjust(
                                                    "add",
                                                    false,
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_add"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      (_vm.tabSelling.grid.selectedRow &&
                                        _vm.isAllowedEdit &&
                                        _vm.isAdjust &&
                                        _vm.config.chargeModifyType > 1 &&
                                        _vm.viewSource !== "salesDetail") ||
                                      (_vm.viewSource === "salesDetail" &&
                                        _vm.privilege
                                          .isSalesPayEditChargeRole &&
                                        _vm.job &&
                                        _vm.job.jobState === 0)
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_edit",
                                                type: "primary",
                                                disabled:
                                                  !_vm.settleBranchEnable ||
                                                  (_vm.viewSource ===
                                                    "salesDetail" &&
                                                    _vm.lockApWithProvision)
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.addCostAdjust(
                                                    "edit",
                                                    false,
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_edit"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      (_vm.tabSelling.grid.selectedRow &&
                                        _vm.isAllowedEdit &&
                                        _vm.isAdjust &&
                                        _vm.config.chargeModifyType > 1) ||
                                      (_vm.viewSource === "salesDetail" &&
                                        _vm.privilege.salesDeleteApDeptCharge &&
                                        _vm.job &&
                                        _vm.job.jobState === 0)
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_delete",
                                                type: "danger",
                                                disabled:
                                                  !_vm.settleBranchEnable ||
                                                  (_vm.viewSource ===
                                                    "salesDetail" &&
                                                    _vm.lockApWithProvision)
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.deleteAdjust(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_delete"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.isAllowedEdit &&
                                      _vm.isAdjust &&
                                      (_vm.privilege.isAdjustmentAddRole ||
                                        _vm.privilege
                                          .isAdjustmentAddRolePositiveNum) &&
                                      _vm.config.chargeModifyType !== 2 &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_newAdjustment",
                                                type: "primary",
                                                disabled:
                                                  !(_vm.job.jobState === 2) ||
                                                  !_vm.settleBranchEnable ||
                                                  _vm.lockApWithProvision
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.addCostAdjust(
                                                    "add",
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_newAdjustment"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.isAllowedEdit &&
                                      _vm.isAdjust &&
                                      _vm.privilege.isAdjustmentEditRole &&
                                      _vm.config.chargeModifyType !== 2 &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_editAdjustment",
                                                type: "primary",
                                                disabled:
                                                  !(
                                                    Number(_vm.job.jobState) ===
                                                      2 &&
                                                    _vm.tabSelling.grid
                                                      .selectedRow &&
                                                    !(
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .billingUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .invoiceUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .billingPaymentUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .confirmBillUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .verifiedAmount !== 0
                                                    )
                                                  ) ||
                                                  !_vm.settleBranchEnable ||
                                                  _vm.lockApWithProvision
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.addCostAdjust(
                                                    "edit",
                                                    false,
                                                    true,
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_editAdjustment"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.isAllowedEdit &&
                                      _vm.isAdjust &&
                                      _vm.privilege.isAdjustmentDeleteRole &&
                                      _vm.config.chargeModifyType !== 2 &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_deleteAdjustment",
                                                type: "danger",
                                                disabled:
                                                  !(
                                                    _vm.job.jobState === 2 &&
                                                    _vm.tabSelling.grid
                                                      .selectedRow &&
                                                    !(
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .billingUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .invoiceUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .billingPaymentUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .confirmBillUuid ||
                                                      _vm.tabSelling.grid
                                                        .selectedRow
                                                        .verifiedAmount !== 0
                                                    )
                                                  ) ||
                                                  !_vm.settleBranchEnable ||
                                                  _vm.lockApWithProvision
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.addCostAdjust(
                                                    "del",
                                                    false,
                                                    true,
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_deleteAdjustment"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.isAllowedEdit &&
                                      _vm.job.masterFlag &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "charge_sp11",
                                                type: "primary",
                                                disabled:
                                                  !_vm.canShareSelling ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.shareChargeSellingHandler()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_sp11"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.privilege.reconciliationDiffAp
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "reconciliationDiffAp",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.reconciliationDiff(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_ReconciliationDiffConfirm"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "charge_writeOffList",
                                            type: "primary",
                                            disabled:
                                              !(
                                                _vm.tabSelling.grid
                                                  .selectedRow &&
                                                _vm.tabSelling.grid.selectedRow
                                                  .clearingDate
                                              ) || !_vm.settleBranchEnable
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.tabChargesHP.btnVerifiedSelling_clickHandler()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "FinanceManage.charge_writeOffList"
                                              )
                                            ) + " "
                                          )
                                        ]
                                      ),
                                      _vm.job.lob === "SE" &&
                                      _vm.config.enableEntrustmentSI &&
                                      _vm.config.chargeSyncNeedConfirm
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "btnSyncApChargesSE",
                                                type: "primary",
                                                disabled:
                                                  _vm.editing ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.syncChargesToImportJob(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_asyncCharges"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.job.lob === "SI" &&
                                      _vm.config.enableEntrustmentSI
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "btnSyncApChargesSI",
                                                type: "primary",
                                                disabled:
                                                  _vm.editing ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.syncChargesToExportJob(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_asyncCharges"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.job.lob === "AE" &&
                                      _vm.config.consignationImportByAE &&
                                      _vm.config.chargeSyncNeedConfirm
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "btnSyncApChargesAE",
                                                type: "primary",
                                                disabled:
                                                  _vm.editing ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.syncChargesToImportJob(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_asyncCharges"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.job.lob === "AI" &&
                                      _vm.config.consignationImportByAE
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "btnSyncApChargesAI",
                                                type: "primary",
                                                disabled:
                                                  _vm.editing ||
                                                  !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.syncChargesToExportJob(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_asyncCharges"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.$checkPermission([
                                        "button_financeModule_audit"
                                      ]) && _vm.config.jinRongExchangeMode
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "syncCloudStarrySkyAp",
                                                disabled:
                                                  _vm.editing ||
                                                  _vm.job.jobState !== 2,
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.syncCloudStarrySky(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.SyncCloudStarrySky"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.isAllowedEdit &&
                                      !_vm.isAdjust &&
                                      !_vm.batchAmendmentFee &&
                                      _vm.privilege.applyAddCharge &&
                                      _vm.config.applyChangeChargeButton &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "applyAddCharge",
                                                type: "primary",
                                                disabled:
                                                  !(_vm.job.jobState === 2) ||
                                                  !_vm.settleBranchEnable ||
                                                  (_vm.config.toExoSystemHC &&
                                                    _vm.lockApWithProvision)
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.applyChangeCharge(
                                                    "add",
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "ChangeCharge.applyAddCharge"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.isAllowedEdit &&
                                      !_vm.isAdjust &&
                                      _vm.privilege.applyChangeCharge &&
                                      _vm.config.applyChangeChargeButton &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "applyChangeCharge",
                                                type: "primary",
                                                disabled:
                                                  !(
                                                    _vm.job.jobState === 2 ||
                                                    (_vm.job.jobState === 1 &&
                                                      _vm.batchAmendmentFee)
                                                  ) ||
                                                  !_vm.settleBranchEnable ||
                                                  (_vm.config.toExoSystemHC &&
                                                    _vm.lockApWithProvision)
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.applyChangeCharge(
                                                    "edit",
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "ChangeCharge.applyChangeCharge"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.isAllowedEdit &&
                                      !_vm.isAdjust &&
                                      !_vm.batchAmendmentFee &&
                                      _vm.privilege.applyDeleteCharge &&
                                      _vm.config.applyChangeChargeButton &&
                                      _vm.viewSource !== "salesDetail"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "applyDeleteCharge",
                                                type: "danger",
                                                disabled:
                                                  !(_vm.job.jobState === 2) ||
                                                  !_vm.settleBranchEnable ||
                                                  (_vm.config.toExoSystemHC &&
                                                    _vm.lockApWithProvision)
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.applyChangeCharge(
                                                    "del",
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "ChangeCharge.applyDeleteCharge"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.job.relatedJob &&
                                      !_vm.editing &&
                                      !_vm.isCrossTenantSeToSi &&
                                      !_vm.config.chargeSyncNeedConfirm
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "asyncChargesToImportJob",
                                                type: "primary",
                                                disabled: !_vm.settleBranchEnable
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.asyncChargesToImportJob(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_asyncChargesToImportJob"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.$checkPermission([
                                                  "button_Charge_lockPayable"
                                                ]) &&
                                                !_vm.lockApWithProvision &&
                                                _vm.showLockButton,
                                              expression:
                                                "$checkPermission(['button_Charge_lockPayable']) && !lockApWithProvision && showLockButton"
                                            }
                                          ],
                                          attrs: {
                                            no: "LockAp",
                                            type: "primary",
                                            disabled:
                                              _vm.editing ||
                                              !_vm.settleBranchEnable
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.tabChargesHP.modifyChargeLockStatus(
                                                false,
                                                1
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("SeaExport.LockAp")) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.lockApWithProvision &&
                                                _vm.showLockButton,
                                              expression:
                                                "lockApWithProvision && showLockButton"
                                            }
                                          ],
                                          attrs: {
                                            no: "UnLockAp",
                                            type: "primary",
                                            disabled:
                                              _vm.editing ||
                                              !_vm.settleBranchEnable ||
                                              !_vm.$checkPermission([
                                                "button_Charge_unLockPayable"
                                              ])
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.tabChargesHP.modifyChargeLockStatus(
                                                false,
                                                0
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("SeaExport.UnLockAp")
                                            ) + " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.$checkPermission([
                                                  "button_Charge_easSync"
                                                ]) &&
                                                _vm.config.toExoSystemEAS &&
                                                _vm.showLockButton &&
                                                _vm.viewSource !==
                                                  "salesDetail",
                                              expression:
                                                "$checkPermission(['button_Charge_easSync']) && config.toExoSystemEAS && showLockButton && viewSource!=='salesDetail'"
                                            }
                                          ],
                                          attrs: {
                                            no: "SyncChargeToEas",
                                            type: "primary",
                                            disabled:
                                              _vm.editing ||
                                              !_vm.settleBranchEnable
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.tabChargesHP.syncChargeToEas(
                                                false
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SeaExport.SyncChargeToEas"
                                              )
                                            ) + " "
                                          )
                                        ]
                                      ),
                                      _vm.isBusinessModuleList &&
                                      _vm.privilege.updateRemarkCharge
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "updateRemarks",
                                                type: "primary",
                                                disabled: !_vm.isOperating
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.updateRemark(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.AdditionalCostRemarks"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.isBusinessFinanceManage &&
                                      _vm.privilege.updateRemarkCharge
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "updateRemarks",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.updateRemark(
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.AdditionalCostRemarks"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.$checkPermission([
                                                "button_Charge_businessQuotation"
                                              ]),
                                              expression:
                                                "$checkPermission(['button_Charge_businessQuotation'])"
                                            }
                                          ],
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.tabChargesHP.businessQuotationChange(
                                                true
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_BusinessQuotationConfirmed"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.$checkPermission([
                                                "button_Charge_businessQuotation"
                                              ]),
                                              expression:
                                                "$checkPermission(['button_Charge_businessQuotation'])"
                                            }
                                          ],
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.tabChargesHP.businessQuotationChange(
                                                false
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_BusinessQuotationConfirmedCancel"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _vm.$checkPermission([
                                        "tab_Charge_chargePayable"
                                      ])
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "btnSyncPayableCharge",
                                                type: "primary",
                                                disabled: !(
                                                  !_vm.job.relatedJob &&
                                                  _vm.job.trustFromJob
                                                )
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.tabChargesHP.syncPayableCharge()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FinanceManage.charge_syncPayable"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c("div", { staticClass: "filters" })
                    ]
                  )
                : _vm._e(),
              _c("cargo-ag-grid-wrapper", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showMergeChargeItemSalesView,
                    expression: "!showMergeChargeItemSalesView"
                  }
                ],
                ref: "tabSellingGrid",
                staticStyle: {
                  "flex-grow": "1",
                  "margin-top": "10px",
                  "padding-right": "10px"
                },
                attrs: {
                  no: "130112",
                  "grid-options": _vm.tabSelling.grid.gridOptions,
                  "grid-params": _vm.tabSelling.grid.gridParams,
                  "column-defs": _vm.dynamicColumnDefsForSelling,
                  "sum-column-defs": _vm.apSumColumnDefs,
                  "config-module": "130112",
                  "row-data": _vm.tabSelling.grid.overseaSellingDetails,
                  "cancel-sort-auto-reduce": false,
                  "min-height": "100px",
                  "show-row-groups": _vm.dataListDragGroup,
                  "show-menu-items": !_vm.showMergeChargeItemSalesView,
                  "pre-column-state-callback": _vm.preColumnStateCallback
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.tabSelling.grid, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.tabSelling.grid, "gridParams", $event)
                  },
                  gridReady: _vm.onSellingGridReady,
                  columnRowGroupChanged: function($event) {
                    _vm.tabSelling.grid.groupColumns = $event
                    _vm.tabSelling.grid.groupRowNode = {}
                  }
                }
              }),
              _c("cargo-ag-grid-wrapper", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showMergeChargeItemSalesView,
                    expression: "showMergeChargeItemSalesView"
                  }
                ],
                ref: "tabSellingGridMerge",
                staticStyle: {
                  "flex-grow": "1",
                  "margin-top": "10px",
                  "padding-right": "10px"
                },
                attrs: {
                  no: "130190",
                  "grid-options": _vm.tabSellingMerge.grid.gridOptions,
                  "grid-params": _vm.tabSellingMerge.grid.gridParams,
                  "column-defs": _vm.dynamicColumnDefsForSellingMerge,
                  "sum-column-defs": _vm.apSumColumnDefs,
                  "config-module": "130190",
                  "row-data": _vm.tabSellingMerge.grid.overseaSellingDetails,
                  "cancel-sort-auto-reduce": false,
                  "min-height": "100px",
                  "show-row-groups": _vm.dataListDragGroup,
                  "show-menu-items": !_vm.showMergeChargeItemSalesView,
                  "pre-column-state-callback": _vm.preColumnStateCallback
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(
                      _vm.tabSellingMerge.grid,
                      "gridParams",
                      $event
                    )
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(
                      _vm.tabSellingMerge.grid,
                      "gridParams",
                      $event
                    )
                  },
                  gridReady: _vm.onSellingMergeGridReady,
                  columnRowGroupChanged: function($event) {
                    _vm.tabSellingMerge.grid.groupColumns = $event
                    _vm.tabSellingMerge.grid.groupRowNode = {}
                  }
                }
              })
            ],
            1
          )
        ],
        2
      ),
      !_vm.isBpm
        ? _c(
            "div",
            {
              staticClass: " operations",
              staticStyle: { "margin-top": "10px" }
            },
            [
              _c("div", { staticClass: "filters" }),
              _c("div", { staticClass: "triggers" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column",
                      width: "100%"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "row"
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Profit")))
                            ]),
                            _vm.reCalc
                              ? _c("charge-currency-total-group", {
                                  attrs: {
                                    no: "profit",
                                    "amount-to-currency": _vm.localCurrency,
                                    "data-field": _vm.config
                                      ._isCalculateExcludingAmount
                                      ? "amount"
                                      : "excludingTaxAmount",
                                    "rate-field": "exchangeRate",
                                    "data-provider":
                                      _vm.revenueTotalGroup.dataProvider,
                                    "is-gross-profit": true,
                                    "show-controlled-profit":
                                      _vm.privilege.showControlledProfit,
                                    "show-controlled":
                                      _vm.privilege.isControlled,
                                    type: "revenue",
                                    "show-cost-controlled":
                                      _vm.privilege.isCostControlled,
                                    source: "chargeDetailAll"
                                  }
                                })
                              : _vm._e(),
                            _vm.config.showGrossProfit
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_GrossMargin")
                                    ) + ": "
                                  )
                                ])
                              : _vm._e(),
                            _vm.config.showGrossProfit
                              ? _c("charge-gross-margin", {
                                  attrs: {
                                    "is-calculate-excluding-amount":
                                      _vm.config._isCalculateExcludingAmount,
                                    "data-provider":
                                      _vm.revenueTotalGroup.dataProvider
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm.showEstimate
                          ? [
                              _c(
                                "span",
                                { staticStyle: { display: "inline-block" } },
                                [
                                  _vm._v(
                                    "(" +
                                      _vm._s(
                                        "" +
                                          _vm.$t(
                                            "FinanceManage.charge_estimate"
                                          ) +
                                          _vm.estimateGrossProfit
                                      ) +
                                      ")"
                                  )
                                ]
                              )
                            ]
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "row"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: { color: "#1890ff", width: "70px" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "FinanceManage.charge_estimateRemarks"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.job.situation,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "situation", $$v)
                                },
                                expression: "job.situation"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.privilege.showOtherBranchCharge,
                                expression: "privilege.showOtherBranchCharge"
                              }
                            ],
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "row"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-left": "10px",
                                  "margin-right": "5px",
                                  "font-weight": "bold"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    this.$t("CargoMsg.Cargo_SettleBranchId")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-select",
                              {
                                staticStyle: {
                                  "margin-right": "5px",
                                  width: "190px"
                                },
                                attrs: {
                                  placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                  clearable: false,
                                  size: "mini"
                                },
                                on: {
                                  change: function(p) {
                                    _vm.tabChargesHP.onSettleBranchIdHandler(p)
                                  }
                                },
                                model: {
                                  value: _vm.settleBranchId,
                                  callback: function($$v) {
                                    _vm.settleBranchId = $$v
                                  },
                                  expression: "settleBranchId"
                                }
                              },
                              _vm._l(_vm.officeList, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.chineseName,
                                    value: item.officeId
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { "margin-left": "10px" } },
                          [
                            _c("el-checkbox", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: (_vm.checkbox.chkLcLCharge.visible =
                                    _vm.job.masterFlag),
                                  expression:
                                    "checkbox.chkLcLCharge.visible=job.masterFlag"
                                }
                              ],
                              attrs: {
                                id: "chkLcLCharge",
                                label: _vm.$t("FinanceManage.charge_sp12"),
                                disabled: _vm.showMergeChargeItemSalesView
                              },
                              on: {
                                change: function($event) {
                                  return _vm.tabChargesHP.chkLcLChargeHandler(
                                    $event
                                  )
                                }
                              },
                              model: {
                                value: _vm.checkbox.chkLcLCharge.selected,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.checkbox.chkLcLCharge,
                                    "selected",
                                    $$v
                                  )
                                },
                                expression: "checkbox.chkLcLCharge.selected"
                              }
                            }),
                            _c("el-checkbox", {
                              attrs: {
                                id: "chkOffset",
                                label: _vm.$t(
                                  "FinanceManage.charge_showRedCharges"
                                ),
                                disabled: _vm.showMergeChargeItemSalesView
                              },
                              on: {
                                change: function($event) {
                                  return _vm.tabChargesHP.chkOffsetChargeHandler(
                                    $event
                                  )
                                }
                              },
                              model: {
                                value: _vm.checkbox.chkOffset.selected,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.checkbox.chkOffset,
                                    "selected",
                                    $$v
                                  )
                                },
                                expression: "checkbox.chkOffset.selected"
                              }
                            }),
                            _c("el-checkbox", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: (_vm.checkbox.chkShowSharedCharge.visible =
                                    _vm.job &&
                                    !_vm.job.masterFlag &&
                                    !_vm.editing),
                                  expression:
                                    "(checkbox.chkShowSharedCharge.visible=job && !job.masterFlag && !editing)"
                                }
                              ],
                              attrs: {
                                id: "chkShowSharedCharge",
                                label: _vm.$t(
                                  "FinanceManage.charge_showSharedCharges"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.tabChargesHP.chkShowSharedChargeHandler(
                                    $event
                                  )
                                }
                              },
                              model: {
                                value:
                                  _vm.checkbox.chkShowSharedCharge.selected,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.checkbox.chkShowSharedCharge,
                                    "selected",
                                    $$v
                                  )
                                },
                                expression:
                                  "checkbox.chkShowSharedCharge.selected"
                              }
                            }),
                            _c("el-checkbox", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: (_vm.checkbox.chkShowCommonCharge.visible =
                                    _vm.privilege.showCommonCharge &&
                                    !_vm.isFromFinanceModule),
                                  expression:
                                    "checkbox.chkShowCommonCharge.visible=(privilege.showCommonCharge && !isFromFinanceModule)"
                                }
                              ],
                              attrs: {
                                id: "chkShowCommonCharge",
                                label: _vm.$t(
                                  "FinanceManage.charge_showCommonCharge"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.tabChargesHP.chkShowCommonChargeHandler(
                                    $event
                                  )
                                }
                              },
                              model: {
                                value:
                                  _vm.checkbox.chkShowCommonCharge.selected,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.checkbox.chkShowCommonCharge,
                                    "selected",
                                    $$v
                                  )
                                },
                                expression:
                                  "checkbox.chkShowCommonCharge.selected"
                              }
                            }),
                            _c("el-checkbox", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: (_vm.checkbox.chkShowSpecialCharge.visible =
                                    _vm.privilege.showSpecialCharge &&
                                    !_vm.isFromFinanceModule),
                                  expression:
                                    "checkbox.chkShowSpecialCharge.visible=(privilege.showSpecialCharge && !isFromFinanceModule)"
                                }
                              ],
                              attrs: {
                                id: "chkShowSpecialCharge",
                                label: _vm.$t(
                                  "FinanceManage.charge_showSpecialCharge"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.tabChargesHP.chkShowCommonChargeHandler(
                                    $event
                                  )
                                }
                              },
                              model: {
                                value:
                                  _vm.checkbox.chkShowSpecialCharge.selected,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.checkbox.chkShowSpecialCharge,
                                    "selected",
                                    $$v
                                  )
                                },
                                expression:
                                  "checkbox.chkShowSpecialCharge.selected"
                              }
                            }),
                            _c("el-checkbox", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: (_vm.checkbox.chkShowBusinessSpecialCharge.visible =
                                    _vm.privilege.showBusinessSpecialCharge &&
                                    !_vm.isFromFinanceModule),
                                  expression:
                                    "checkbox.chkShowBusinessSpecialCharge.visible=(privilege.showBusinessSpecialCharge && !isFromFinanceModule)"
                                }
                              ],
                              attrs: {
                                id: "chkShowBusinessSpecialCharge",
                                label: _vm.$t(
                                  "FinanceManage.charge_showBusinessSpecialCharge"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.tabChargesHP.chkShowCommonChargeHandler(
                                    $event
                                  )
                                }
                              },
                              model: {
                                value:
                                  _vm.checkbox.chkShowBusinessSpecialCharge
                                    .selected,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.checkbox.chkShowBusinessSpecialCharge,
                                    "selected",
                                    $$v
                                  )
                                },
                                expression:
                                  "checkbox.chkShowBusinessSpecialCharge.selected"
                              }
                            }),
                            _c("el-checkbox", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false"
                                }
                              ],
                              attrs: {
                                id: "chkShowChangeCharge",
                                label: _vm.$t(
                                  "CargoMsg.Cargo_DisplaysTheRequestChangeFee"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.tabChargesHP.chkShowChangeChargeHandler(
                                    $event
                                  )
                                }
                              },
                              model: {
                                value:
                                  _vm.checkbox.chkShowChangeCharge.selected,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.checkbox.chkShowChangeCharge,
                                    "selected",
                                    $$v
                                  )
                                },
                                expression:
                                  "checkbox.chkShowChangeCharge.selected"
                              }
                            }),
                            _vm.pendingChargeSyncRecordNum > 0
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "red",
                                      cursor: "pointer"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.tabChargesHP.showChargeSyncRecord()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticStyle: {
                                          "text-decoration": "underline"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.pendingChargeSyncRecordNum)
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "FinanceManage.synchronizationFeesToBeProcessed"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.pendingChargeOutSyncRecordNum > 0
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "red",
                                      cursor: "pointer"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.tabChargesHP.showChargeOutSyncRecord()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticStyle: {
                                          "text-decoration": "underline"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.pendingChargeOutSyncRecordNum
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.SupplierFeesToBeProcessed"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c("el-checkbox", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.checkbox.chkInternal.visible,
                                  expression: "checkbox.chkInternal.visible"
                                }
                              ],
                              attrs: {
                                id: "chkInternal",
                                label: _vm.$t(
                                  "CargoMsg.Cargo_ShowInternalCharges"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.tabChargesHP.chkInternalChargeHandler(
                                    $event
                                  )
                                }
                              },
                              model: {
                                value: _vm.checkbox.chkInternal.selected,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.checkbox.chkInternal,
                                    "selected",
                                    $$v
                                  )
                                },
                                expression: "checkbox.chkInternal.selected"
                              }
                            }),
                            _c("el-checkbox", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !_vm.isAdjust &&
                                    _vm.job.masterFlag &&
                                    _vm.config.automaticAllocation &&
                                    _vm.viewSource !== "salesDetail",
                                  expression:
                                    "!isAdjust && job.masterFlag && config.automaticAllocation && viewSource!=='salesDetail'"
                                }
                              ],
                              attrs: {
                                id: "automaticAllocation",
                                label: _vm.$t(
                                  "CargoMsg.Cargo_AutomaticAllocation"
                                ),
                                disabled:
                                  !_vm.editing || !_vm.settleBranchEnable
                              },
                              model: {
                                value: _vm.job.automaticAllocation,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "automaticAllocation", $$v)
                                },
                                expression: "job.automaticAllocation"
                              }
                            })
                          ],
                          1
                        ),
                        _c("div", { staticClass: "gp-explain" }, [
                          _c(
                            "span",
                            {
                              staticClass: "gp-explain-click",
                              attrs: { no: "gpExplainClick" },
                              on: {
                                click: function($event) {
                                  _vm.gpExplain.visible = true
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("FinanceManage.GpExplain")))]
                          ),
                          _vm.gpExplain.gpExplainContent
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.gpExplain.gpExplainContent,
                                        placement: "top-start"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "gp-explain-ellipsis" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.gpExplain.gpExplainContent
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ],
                      2
                    )
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      _c("adjust-window", {
        attrs: {
          visible: _vm.adjustWindow.visible,
          "default-properties": _vm.adjustWindow.defaultProperties,
          "view-source": _vm.isFromFinanceModule ? "FinanceManage" : "",
          location: _vm.location
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.adjustWindow, "visible", $event)
          },
          returnCall: function() {
            _vm.tabChargesHP.clickHandler1Handler()
          }
        }
      }),
      _c("delete-adjust-dialog", {
        attrs: {
          visible: _vm.batchDeleteAdjustWindow.visible,
          charges: _vm.batchDeleteAdjustWindow.charges,
          job: _vm.batchDeleteAdjustWindow.job,
          "is-ar": _vm.batchDeleteAdjustWindow.isAr,
          location: _vm.location
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchDeleteAdjustWindow, "visible", $event)
          },
          returnCall: function() {
            _vm.tabChargesHP.clickHandler1Handler()
          }
        }
      }),
      _vm.changeChargeDialog.visible
        ? _c("change-charge-dialog", {
            attrs: {
              visible: _vm.changeChargeDialog.visible,
              "default-properties": _vm.changeChargeDialog.defaultProperties,
              "input-including-tax-unit-price":
                _vm.config.inputIncludingTaxUnitPrice,
              "show-wht-tax": _vm.showWhtTax
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.changeChargeDialog, "visible", $event)
              },
              close: function($event) {
                _vm.changeChargeDialog.visible = false
              },
              returnCall: function() {
                _vm.tabChargesHP.clickHandler1Handler()
              }
            }
          })
        : _vm._e(),
      _c("change-charge-work-flow-dialog", {
        ref: "ccwDialog",
        attrs: {
          visible: _vm.changeChargeWorkFlowDialog.visible,
          job: _vm.changeChargeWorkFlowDialog.job,
          privilege: _vm.changeChargeWorkFlowDialog.privilege,
          params: _vm.changeChargeWorkFlowDialog.params,
          config: _vm.config,
          "show-wht-tax": _vm.showWhtTax,
          "office-list": _vm.changeChargeWorkFlowDialog.officeList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.changeChargeWorkFlowDialog, "visible", $event)
          },
          close: function($event) {
            _vm.changeChargeWorkFlowDialog.visible = false
          },
          returnCall: function() {
            _vm.tabChargesHP.clickHandler1Handler()
          }
        }
      }),
      _c("change-charge-window", {
        attrs: {
          visible: _vm.changeChargeWindow.visible,
          "default-properties": _vm.changeChargeWindow.defaultProperties,
          "apply-change-charge": _vm.changeChargeWindow.applyChangeCharge,
          location: _vm.location,
          "customer-sales-display-star":
            _vm.changeChargeWindow.customerSalesDisplayStar
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.changeChargeWindow, "visible", $event)
          },
          returnCall: function() {
            _vm.tabChargesHP.clickHandler1Handler()
          }
        }
      }),
      _c("special-charge-window", {
        attrs: {
          visible: _vm.specialChargeWindow.visible,
          "default-properties": _vm.specialChargeWindow.defaultProperties,
          location: _vm.location
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.specialChargeWindow, "visible", $event)
          },
          returnCall: function() {
            _vm.tabChargesHP.clickHandler1Handler()
          }
        }
      }),
      _c("business-special-charge-window", {
        attrs: {
          visible: _vm.businessSpecialChargeWindow.visible,
          "default-properties":
            _vm.businessSpecialChargeWindow.defaultProperties,
          location: _vm.location
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.businessSpecialChargeWindow, "visible", $event)
          },
          returnCall: function() {
            _vm.tabChargesHP.clickHandler1Handler()
          }
        }
      }),
      _c("charge-scheme-batch-dialog", {
        attrs: {
          visible: _vm.chargePlanDialog.visible,
          lob: _vm.chargePlanDialog.lob,
          "is-sea": _vm.chargePlanDialog.isSea,
          "original-condition": _vm.chargePlanDialog.originalCondition,
          "charge-scheme-is-approved":
            _vm.chargePlanDialog.chargeSchemeIsApproved,
          source: _vm.chargePlanDialog.source,
          job: _vm.job,
          location: _vm.location,
          "sale-role-hide": _vm.saleRoleHide
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.chargePlanDialog, "visible", $event)
          },
          selectedSchemeHandler: function(schemeDetails) {
            _vm.tabChargesHP.selectedSchemeHandler(schemeDetails)
          }
        }
      }),
      _c("copy-charge-dialog", {
        attrs: {
          visible: _vm.copyChargeDialog.visible,
          lob: _vm.copyChargeDialog.lob,
          "is-sea": _vm.copyChargeDialog.isSea,
          job: _vm.job,
          "view-source": _vm.viewSource
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyChargeDialog, "visible", $event)
          },
          selectedCopyChargeHandler: function(chargeList) {
            _vm.tabChargesHP.selectedCopyChargeHandler(chargeList)
          }
        }
      }),
      _c("verified-dialog", {
        attrs: {
          visible: _vm.verifiedDialog.visible,
          charge: _vm.verifiedDialog.charge
        },
        on: {
          cancel: function($event) {
            _vm.verifiedDialog.visible = false
          }
        }
      }),
      _c("copy-slave-cost-dialog", {
        attrs: {
          visible: _vm.copySlaveCostDialog.visible,
          params: _vm.copySlaveCostDialog.params,
          "uuid-prefix-rule": _vm.tabCost.grid.uuidPrefixRule
        },
        on: {
          success: _vm.copySlaveCostSuccessHandler,
          cancel: function($event) {
            _vm.copySlaveCostDialog.visible = false
          }
        }
      }),
      _vm.isAllowedEdit && !_vm.isAdjust && _vm.editing
        ? _c("fcl-price-dialog", {
            attrs: { visible: _vm.addPriceDialog.visible, job: _vm.job },
            on: {
              close: function($event) {
                _vm.addPriceDialog.visible = false
              },
              itemSelected: _vm.onFCLSelected
            }
          })
        : _vm._e(),
      _vm.isAllowedEdit && !_vm.isAdjust && _vm.editing
        ? _c("lcl-price-dialog", {
            attrs: { visible: _vm.lclPriceDialog.visible, job: _vm.job },
            on: {
              close: function($event) {
                _vm.lclPriceDialog.visible = false
              },
              itemSelected: _vm.onLCLSelected
            }
          })
        : _vm._e(),
      _vm.isAllowedEdit && _vm.job.masterFlag
        ? _c("charge-share-dialog", {
            attrs: {
              visible: _vm.shareChargeDialog.visible,
              job: _vm.shareChargeDialog.job,
              charges: _vm.shareChargeDialog.charges,
              "diff-charge-keys": _vm.shareChargeDialog.diffChargeKeys,
              location: _vm.location
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.shareChargeDialog, "visible", $event)
              },
              chargeShared: function($event) {
                return _vm.tabChargesHP.chargeSharedHandler()
              }
            }
          })
        : _vm._e(),
      _c("settlement-select-dialog", {
        attrs: {
          visible: _vm.settlementSelectDialog.visible,
          title: _vm.settlementSelectDialog.title,
          accounts: _vm.settlementSelectDialog.accounts,
          source: "tabCharges"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.settlementSelectDialog, "visible", $event)
          },
          selectItemWinHandler: _vm.selectItemWinHandler
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("estimate-validation-dialog", {
        ref: "estimateValidationDialog",
        attrs: {
          visible: _vm.estimateValidationDialog.visible,
          job: _vm.estimateValidationDialog.job,
          "estimate-profit-rate":
            _vm.estimateValidationDialog.estimateProfitRate,
          "tatol-profit": _vm.estimateValidationDialog.tatolProfit,
          editable: _vm.estimateValidationDialog.editable
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.estimateValidationDialog, "visible", $event)
          },
          callback: _vm.estimateValidationDialog.callback
        }
      }),
      _vm.showChargeSyncRecord
        ? _c("charge-sync-record-dialog", {
            attrs: {
              visible: _vm.chargeSyncRecordDialog.visible,
              job: _vm.chargeSyncRecordDialog.job,
              "charge-sync-check-job-state": _vm.config.chargeSyncCheckJobState,
              location: _vm.location
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.chargeSyncRecordDialog, "visible", $event)
              },
              callback: _vm.chargeSyncConfirmCallback
            }
          })
        : _vm._e(),
      _c("charge-out-sync-record-dialog", {
        attrs: {
          visible: _vm.chargeOutSyncRecordDialog.visible,
          job: _vm.chargeOutSyncRecordDialog.job,
          "charge-sync-check-job-state": _vm.config.chargeSyncCheckJobState,
          location: _vm.location
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.chargeOutSyncRecordDialog, "visible", $event)
          },
          callback: _vm.chargeOutSyncConfirmCallback
        }
      }),
      _vm.addChargeDialog.visible
        ? _c("add-charge-dialog", {
            attrs: {
              visible: _vm.addChargeDialog.visible,
              "input-including-tax-unit-price":
                _vm.config.inputIncludingTaxUnitPrice,
              "default-properties": _vm.addChargeDialog.defaultProperties,
              location: _vm.location,
              config: _vm.config
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.addChargeDialog, "visible", $event)
              },
              close: function($event) {
                _vm.addChargeDialog.visible = false
              },
              returnCall: function() {
                _vm.tabChargesHP.clickHandler1Handler()
              }
            }
          })
        : _vm._e(),
      _vm.changingChargeDetailDialog.visible
        ? _c("changing-charge-detail-dialog", {
            attrs: {
              visible: _vm.changingChargeDetailDialog.visible,
              "job-uuid": _vm.job.uuid
            },
            on: {
              onCancel: function($event) {
                _vm.changingChargeDetailDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.updateDueDateDialogDialog.visible
        ? _c("update-due-date-dialog", {
            attrs: { visible: _vm.updateDueDateDialogDialog.visible },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.updateDueDateDialogDialog,
                  "visible",
                  $event
                )
              },
              returnCall: function(dueDate) {
                _vm.tabChargesHP.confirmUpdateDueDate(dueDate)
              }
            }
          })
        : _vm._e(),
      _vm.updateRemarkDialog.visible
        ? _c("update-remark-dialog", {
            attrs: { visible: _vm.updateRemarkDialog.visible },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.updateRemarkDialog, "visible", $event)
              },
              returnCall: function(remark) {
                _vm.tabChargesHP.confirmUpdateRemark(remark)
              }
            }
          })
        : _vm._e(),
      _vm.changeAccountIdDialog.visible
        ? _c("change-account-id-dialog", {
            attrs: {
              visible: _vm.changeAccountIdDialog.visible,
              "is-ar": _vm.changeAccountIdDialog.isAr,
              "company-factory-signs":
                _vm.changeAccountIdDialog.companyFactorySigns
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.changeAccountIdDialog, "visible", $event)
              },
              changeAccountId: function(p) {
                _vm.tabChargesHP.changeAccountCallBack(p)
              }
            }
          })
        : _vm._e(),
      _vm.beforeAndAfterComparisonDialogBpm.visible
        ? _c("before-and-after-comparison-dialog-bpm", {
            attrs: {
              visible: _vm.beforeAndAfterComparisonDialogBpm.visible,
              "change-reason":
                _vm.beforeAndAfterComparisonDialogBpm.changeReason,
              "ar-charge-before":
                _vm.beforeAndAfterComparisonDialogBpm.arChargeBefore,
              "ap-charge-before":
                _vm.beforeAndAfterComparisonDialogBpm.apChargeBefore,
              "ar-charge-after":
                _vm.beforeAndAfterComparisonDialogBpm.arChargeAfter,
              "ap-charge-after":
                _vm.beforeAndAfterComparisonDialogBpm.apChargeAfter,
              "charge-original-profit":
                _vm.beforeAndAfterComparisonDialogBpm.chargeOriginalProfit,
              "charge-change-profit":
                _vm.beforeAndAfterComparisonDialogBpm.chargeChangeProfit,
              "ap-tip": _vm.beforeAndAfterComparisonDialogBpm.apTip,
              "ar-tip": _vm.beforeAndAfterComparisonDialogBpm.arTip
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.beforeAndAfterComparisonDialogBpm,
                  "visible",
                  $event
                )
              },
              onCancel: function() {
                _vm.beforeAndAfterComparisonDialogBpm.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.gpExplain.visible
        ? _c("add-gp-explain-dialog", {
            attrs: {
              type: _vm.gpExplain.type,
              visible: _vm.gpExplain.visible,
              "job-uuids": [_vm.job.uuid]
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.gpExplain, "visible", $event)
              },
              callback: _vm.getGpExplainRecordByJobUuid
            }
          })
        : _vm._e(),
      _vm.reconciliationDiffDialog.visible
        ? _c("reconciliation-diff-confirm-dialog", {
            attrs: { visible: _vm.reconciliationDiffDialog.visible },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.reconciliationDiffDialog, "visible", $event)
              },
              returnCall: function(reason) {
                _vm.tabChargesHP.confirmReconciliationDiff(reason)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }